<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    title="我的菜单"
    width="600px"
    @close="close"
  >
    <div class="list">
      <div class="cell" v-for="(item, index) of dyRoutes" :key="item.name">
        <div class="cell-left">
          <vab-icon
            v-if="item.meta.icon"
            :icon="item.meta.icon"
            :is-custom-svg="item.meta.isCustomSvg"
            class="menu-icon"
          />
          <span>
            {{ item.meta.title }}
          </span>
        </div>
        <div class="cell-right">
          <vab-icon
            icon="arrow-up-line"
            class="action-icon"
            v-if="index !== 0"
            @click="sort('up', index)"
          />
          <vab-icon
            icon="arrow-down-line"
            class="action-icon"
            v-if="index != dyRoutes.length - 1"
            @click="sort('down', index)"
          />
          <vab-icon
            icon="close-line"
            class="action-icon"
            @click="sort('close', index)"
          />
        </div>
      </div>
    </div>
    <div v-if="dyRoutes.length === 0">暂无最近打开菜单</div>
    <template #footer>
      <el-button @click="close">关闭</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { ref, computed, watchEffect, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import storejs from 'store'
export default {
  name: 'MyMenu',
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    // const dyRoutes = computed(() =>
    //   store.getters['routes/dynamicRoutes'].length
    //     ? store.getters['routes/dynamicRoutes']
    //     : storejs.get('dynamicRoutes') || []
    // )
    const dialogFormVisible = ref(false)
    const dyRoutes = ref([])
    const getDy = () => {
      dyRoutes.value = store.getters['routes/dynamicRoutes'].length
        ? store.getters['routes/dynamicRoutes']
        : storejs.get('dynamicRoutes') || []
    }
    const sort = (command, index) => {
      if (command === 'up') {
        //上移
        dyRoutes.value.splice(
          index,
          1,
          ...dyRoutes.value.splice(index - 1, 1, dyRoutes.value[index])
        )
        store.dispatch('routes/setDynamicRoutes', [...dyRoutes.value])
        storejs.set('dynamicRoutes', [...dyRoutes.value])
      } else if (command === 'down') {
        dyRoutes.value.splice(
          index,
          1,
          ...dyRoutes.value.splice(index + 1, 1, dyRoutes.value[index])
        )
        store.dispatch('routes/setDynamicRoutes', [...dyRoutes.value])
        storejs.set('dynamicRoutes', [...dyRoutes.value])
      } else if (command === 'close') {
        const path = dyRoutes.value[index]
        const currentPath = route.matched[0].path
        //移除
        dyRoutes.value.splice(index, 1)
        store.dispatch('routes/setDynamicRoutes', [...dyRoutes.value])
        storejs.set('dynamicRoutes', [...dyRoutes.value])
        console.log(store.getters['routes/dynamicRoutes'])
        if (path.path === currentPath) {
          //关闭自身
          if (dyRoutes.value.length != 0) {
            router.push(dyRoutes.value[0])
          } else {
            router.push('/widget')
          }
        }
        if (dyRoutes.value.length === 0) {
          dialogFormVisible.value = false
        }
      }
    }
    return {
      dialogFormVisible,
      dyRoutes,
      sort,
      getDy,
    }
  },
  methods: {
    showMenu() {
      this.getDy()
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
}
.cell {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cell-left {
  display: flex;
  align-items: center;
}
.menu-icon {
  font-size: 26px;
}
.action-icon {
  font-size: 18px;
}
</style>
